import styled from 'styled-components';
import { IThemeProvider } from '../../../../../styles/theme';

export const Wrapper = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding-top: 40px;
`;

export const Table = styled.table`
  width: 100%;
`;

export const HeaderRow = styled.tr`
  display: grid;
  grid-template-columns: 5fr 1fr 1fr 8fr;
  padding-bottom: 16px;
  ${({ theme }: IThemeProvider) => `
      border-bottom: 1px solid ${theme.colors.neutral.primary[30]};
  `};
`;

export const HeaderCell = styled.th<IThemeProvider>`
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 16px;
  ${({ theme }) => `
    color:  ${theme.colors.neutral.primary[80]};
  `}
  &:first-child {
    justify-content: left;
    margin-left: 4rem;
  }
  &:nth-child(4) {
    margin: 0 2.5rem 0 1rem;
    display: flex;
    justify-content: space-between;
  }
`;
